import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/lib/i18n";

function App() {
    return (
        <I18nProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                theme="dark"
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#0F0F14",
                        border: "1px solid rgba(30,107,255,0.35)",
                        color: "#E8EAED",
                    },
                }}
            />
        </I18nProvider>
    );
}

export default App;
